import * as React from 'react';
import styles from './ItinerarySideModal.module.css';
import { Itinerary } from 'models/itinerary';
import { useMapDisplayContext } from '../MapDisplayContext';
import clsx from 'clsx';
import { SideModalItineraryList } from './SideModalItineraryList';
import { ItineraryDetails } from '../Itineraries/ItineraryDetails/ItineraryDetails';

interface ItinerarySideModalProps {
  onClose: () => void;
  open?: boolean;
}

export const ItinerarySideModal = ({ onClose, open = false }: ItinerarySideModalProps) => {
  const { replaceUrlParams } = useMapDisplayContext();

  const [activeItinerary, setActiveItinerary] = React.useState<Itinerary | null>(null);

  const onCreateItineraryClick = () => {
    onClose();
    replaceUrlParams({ pg: 'ITINERARIES.CREATE' });
  };

  const onItineraryClick = (itinerary: Itinerary) => {
    setActiveItinerary(itinerary);
  };

  const onItineraryExpandClick = () => {
    onClose();
    replaceUrlParams({ pg: 'ITINERARIES.DETAILS', itin: activeItinerary?.id });
  };

  if (!open) return null;

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />
      <div className={clsx(styles['modal-content'], styles.open)}>
        {activeItinerary ? (
          <ItineraryDetails
            itinerary={activeItinerary}
            onBackClick={() => setActiveItinerary(null)}
            alwaysMaximized
            onExpandClick={onItineraryExpandClick}
          />
        ) : (
          <SideModalItineraryList
            onEnlargeClick={() => {
              onClose();
              replaceUrlParams({ pg: 'ITINERARIES.LIST' });
            }}
            onCreateItineraryClick={onCreateItineraryClick}
            onItineraryClick={onItineraryClick}
          />
        )}
      </div>
    </>
  );
};
